import qs from 'qs';
import { LocalStorage } from '@/core/Storage';

type OauthManagerParams = {
  action?: string;
  'return-to'?: string;
};

const STORAGE_KEY = 'oauthManager';
class OauthStore {
  private params: OauthManagerParams;
  constructor() {
    this.params = {};
  }
  init() {
    const search = decodeURIComponent(window.location.search);
    const queryParams = qs.parse(search.slice(1));
    const storageValue = sessionStorage.getItem(STORAGE_KEY);
    const savedParams = storageValue ? JSON.parse(storageValue) : undefined;
    if (queryParams?.action === 'auth' && typeof queryParams?.['return-to'] === 'string') {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(queryParams));
    }
    this.params = queryParams?.action === 'auth' && typeof queryParams?.['return-to'] === 'string' ? queryParams : savedParams;
  }
  redirect(accountID?: string) {
    if (this.params?.action === 'auth' && typeof this.params?.['return-to'] === 'string' && accountID) {
      const redirectURL = this.params['return-to'];
      const token = LocalStorage.getItem(['token', accountID].filter(Boolean).join('-')) || LocalStorage.getItem('token');
      if (!token) return false;
      sessionStorage.removeItem(STORAGE_KEY);
      this.params = {};
      window.location.href = `${redirectURL}?CORE_JWT=${token}`;
    }
    return false;
  }
}

export const OauthManager = new OauthStore();
